import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { DISPLAY, formatQ, Truck, Close } from '../home/ui';
import { Card, CardHead, PageHead, Pill, Steps, BoxIcon, orderStatus, payStatus, fecha, orderLabel, gbtn, EmptyCard, pbtn } from '../account/shared';

// Resumen de la cuenta: contadores, el pedido en curso y los recientes.
// Todo sale de GET /store/orders/{id}/all, que ya cargó el layout.

const Stat = ({ icon, tone, value, label }) => (
    <Card className='flex items-center gap-[14px] !p-5'>
        <div className={`w-12 h-12 rounded-[14px] grid place-items-center flex-shrink-0 ${tone}`}>{icon}</div>
        <div>
            <b className='block text-[#1e3a8a] text-[28px] leading-none mb-[3px]' style={DISPLAY}>{value}</b>
            <span className='text-[13px] text-[#64748b]'>{label}</span>
        </div>
    </Card>
);

const Index = () => {
    const { userInfo } = useSelector(state => state.auth);
    const { myOrders } = useSelector(state => state.order);

    const enProceso = myOrders.filter(o => orderStatus(o.delivery_status).group === 'proc');
    const cancelados = myOrders.filter(o => orderStatus(o.delivery_status).group === 'no');
    const actual = enProceso[0];
    const nombre = (userInfo?.name || '').split(' ')[0];

    return (
        <section>
            <PageHead title={`Hola${nombre ? `, ${nombre}` : ''}`} sub='Aquí ves el estado de tus pedidos y lo que guardaste para después.' />

            <div className='grid grid-cols-3 sm:grid-cols-1 gap-[14px] mb-[14px]'>
                <Stat value={myOrders.length} label='Pedidos realizados' tone='bg-[#ecfeff] text-[#0891b2]' icon={<BoxIcon className='w-[22px] h-[22px]' />} />
                <Stat value={enProceso.length} label='En proceso' tone='bg-[#fef3c7] text-[#b45309]' icon={<Truck className='w-[22px] h-[22px]' />} />
                <Stat value={cancelados.length} label='Cancelados' tone='bg-[#fee2e2] text-[#b91c1c]' icon={<Close className='w-[22px] h-[22px]' />} />
            </div>

            {actual && (
                <Card className='mb-[14px]'>
                    <div className='flex justify-between items-start gap-4 flex-wrap mb-[18px]'>
                        <div>
                            <span className='text-[12px] font-bold text-[#64748b] tracking-[.06em] uppercase'>Pedido {orderLabel(actual)} · {orderStatus(actual.delivery_status).label}</span>
                            <h3 className='text-[#1e3a8a] text-[20px] font-bold mt-1 mb-0' style={DISPLAY}>{orderStatus(actual.delivery_status).headline}</h3>
                            {actual.promised_date && (
                                <div className='text-[13.5px] text-[#334155] mt-1'>Entrega estimada: <b className='text-[#0f172a]'>{fecha(actual.promised_date, { weekday: 'short', day: 'numeric', month: 'short' })}</b></div>
                            )}
                        </div>
                        <Link to={`/dashboard/order/details/${actual._id}`} className={gbtn}><Truck className='w-4 h-4' />Ver seguimiento</Link>
                    </div>
                    <Steps status={actual.delivery_status} />
                </Card>
            )}

            {myOrders.length === 0 ? (
                <EmptyCard icon={<BoxIcon className='w-[26px] h-[26px]' />} title='Todavía no tienes pedidos' text='Cuando hagas tu primer pedido lo verás aquí.'>
                    <Link to='/shops' className={pbtn}>Ir a la tienda</Link>
                </EmptyCard>
            ) : (
                <Card>
                    <CardHead title='Pedidos recientes'>
                        <Link to='/dashboard/my-orders' className='text-[13.5px] font-bold text-[#0891b2]'>Ver todos →</Link>
                    </CardHead>
                    <div className='overflow-x-auto -mx-6 px-6'>
                        <table className='w-full text-[14px] border-collapse min-w-[560px]'>
                            <thead>
                                <tr className='text-left text-[11.5px] uppercase tracking-[.05em] text-[#64748b]'>
                                    {['Pedido', 'Fecha', 'Total', 'Pago', 'Estado', ''].map(h => <th key={h} className='font-semibold pb-3 border-b border-[#f1efea]'>{h}</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {myOrders.slice(0, 4).map(o => {
                                    const st = orderStatus(o.delivery_status), pay = payStatus(o.payment_status);
                                    return (
                                        <tr key={o._id} className='border-b border-[#f1efea] last:border-b-0'>
                                            <td className='py-3 font-bold text-[#0f172a]'>{orderLabel(o)}</td>
                                            <td className='py-3 text-[#334155]'>{fecha(o.date)}</td>
                                            <td className='py-3 font-bold text-[#0f172a]'>{formatQ(o.price)}</td>
                                            <td className='py-3'><Pill kind={pay.kind}>{pay.label}</Pill></td>
                                            <td className='py-3'><Pill kind={st.kind}>{st.label}</Pill></td>
                                            <td className='py-3 text-right'><Link to={`/dashboard/order/details/${o._id}`} className='text-[13.5px] font-bold text-[#0891b2]'>Ver detalle</Link></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </Card>
            )}
        </section>
    );
};

export default Index;
